import { retailAutomationActions, selectRetailAutomationId } from './retailAutomation.slicer';
import { getAppState } from '../../store';
import { RETAIL_AUTOMATION_ROUTE, RETAIL_AUTOMATION_ROUTE_V2, RETAIL_AUTOMATION_TAB_ROUTE, RETAIL_AUTOMATION_TAB_ROUTE_V2 } from '../../../constants/routePathConstants';
import { history } from '../../../history';
import { dispatcher } from '../../../helpers/projectHelper';
import { deleteRetailAutomationApi } from '../../../api/retailAutomationApis';
import { successToast } from '../../../helpers/toastHelper';
import { paginatedProductActions } from '../admin/paginatedProductSlicer';
import { setReplacePropActive } from '../admin/shortcutsModuleSlicer';
import { setSidebarSection } from '../admin/curatorSlicer';

export const setSidebarTab = (tabName) => {
  dispatcher(retailAutomationActions.setActiveTab(tabName));
};

export const openTab = (tab, indexData = null, automationId) => {
  dispatcher(retailAutomationActions.setShowAddProp(false));
  dispatcher(setSidebarSection(null));
  dispatcher(setReplacePropActive(false));
  dispatcher(paginatedProductActions.setSearch(''));
  if (tab !== 'style') {
    dispatcher(retailAutomationActions.setEnableStyleSection(false));
  }
  const id = selectRetailAutomationId(getAppState());
  // RETAIL_AUTOMATION_TAB_ROUTE
  const url = RETAIL_AUTOMATION_TAB_ROUTE_V2.replace(':automationId', (id || automationId)).replace(':tabName', tab);
  setSidebarTab(tab);
  history.replace(url);
  if (indexData?.row) {
    dispatcher(retailAutomationActions.setFillTrayData(null));
    dispatcher(retailAutomationActions.setCardIndexClicked(indexData));
  }
};

export const deleteRetailAutomation = async (id) => {
  // TODO: prevent scene from saving if configurator is deleted
  const success = await dispatcher(deleteRetailAutomationApi(id));
  if (success?.status) {
    successToast('Retail automation deleted successfully');
    history.replace(RETAIL_AUTOMATION_ROUTE_V2); // RETAIL_AUTOMATION_ROUTE;
  }
};
